import React from 'react'

export interface ListError {
  key?: string | null | undefined
  value?: string | null | undefined
}
export interface ListWarning {
  key?: string | null | undefined
  value?: string | null | undefined
}
export interface SessionData {
  isOverridden?: boolean | null | undefined
  name?: string | null | undefined
  sequence?: string | null | undefined
  fiveMod?: string | null | undefined
  threeMod?: string | null | undefined | null
  purification?: string | null | undefined
  baseCount?: number | null | undefined
  format?: string | null | undefined
  scale?: string | null | undefined | null
  concentration?: string | null | undefined
  tubes?: string | null | undefined
  price?: string | null | undefined
  orderItemId?: string | null | undefined
  id?: string | null | undefined
  applyToAll?: boolean | null | undefined | null
  comments?: string | null | undefined
  additionalComments?: string | null | undefined
  fullSOligoBackbone?: boolean | null | undefined
  otherValue?: string | null | undefined
  nterminalMod?: string | null | undefined
  cterminalMod?: string | null | undefined
  fiveModCategory?: string | null | undefined
  threeModCategory?: string | null | undefined
  internalModCategory?: string | null | undefined
  material?: string | null | undefined
  crossContamination?: string | null | undefined
  plateType?: string | null | undefined
  packageType?: string | null | undefined
  isoCode?: boolean | null | undefined | null
  crRnaType?: string | null | undefined
  customPeptideType?: string | null | undefined
  sequenceLocation?: string | null | undefined
  carrierProtein?: string | null | undefined
  oligoId?: number | null | undefined
  countryCode?: string | null | undefined
  autoValidation?: string | null | undefined
  productType?: string | null | undefined
  listError?: ListError[] | null | any
  listWarning?: ListWarning[] | null | any
  molecularWeight?: string | null | undefined
  gcContent?: string | null | undefined
  primerDimer?: string | null | undefined
  secondaryStructure?: string | null | undefined
  currencySymbol?: string | null | undefined
  currency?: string | null | undefined
  amount?: string | null | undefined
  shipping?: string | null | undefined
  isLabelledAminoAcid?: boolean | null | undefined
  quantitation?: string | null | undefined
  purityLevel?: string | null | undefined
  priceHeaderError?: string | null | undefined
  cartId?: string | null | undefined
  itemId?: string | null | undefined
  conjugation?: string | null | undefined
  conjugationAmount?: string | null | undefined
  conjugationChemistry?: string | null | undefined
  additionalCarrierProtein?: string | null | undefined
  minimumYield?: string | null | undefined
  meltingTemparature?: string | null | undefined
  epsilon?: number | null | undefined
  additionalServices: string[]
  flag: number
  probeType?: string | null | undefined
  internalMod?: string | null | undefined
  isLNABaseEnable?: boolean | null | undefined
}

export interface SetSequenceData {
  sequenceData: string
  selectionData: string
  error: string
  position: number
  baseCount: number
  seqLength: number
}

export interface RuleValidationData {
  internalMod: string
  probeType: string
  name: string
  sequence: string
  purification: string
  threeMod: string
  fiveMod: string
  scale: string
  format: string
  concentration: string
  tubes: string
  researcher: string
  countryCode: string
  fullSOligoBackbone: boolean
  isOverridden: boolean
  comments: string
  cterminalMod: string
  nterminalMod: string
  otherValue?: string | null | undefined
  amount: string
  isLabelledAminoAcid: boolean
  quantitation: string
  purityLevel: string
  conjugation: string
  conjugationAmount: string
  conjugationChemistry: string
  additionalCarrierProtein: string
  additionalServices: string[]
  flag: number
}

export interface TubeTotalValidation {
  listErrors: [ListError]
}

export interface ProductInformationResponse {
  productType?: string | null | undefined
  typeCode?: string | null | undefined
  packageType?: string | null | undefined
  instructions?: string | null | undefined
  brand?: string | null | undefined
  shippingOptions?: any[] | null | undefined
  companionProducts?: any[] | null | undefined
  currencyFormat?: string
  decimalSeparator?: string
  thousandSeparator?: string
  prefixCurrecny?: boolean
  thousandSpacing?: string
}

export interface StandardState {
  sessionData: SessionData[]
  errorData: RuleValidationData
  errorResponseJson: any
  seqLength: number
  isSequenceValid: boolean
  currentOligoIndex: number
  setSequenceData: SetSequenceData
  totalValidation: TubeTotalValidation
  callTotalValidation: boolean
  oligoCount: number
  addOligo: boolean
  isValidTotalValidation: boolean
  optionalBases?: string | null | undefined
  isPageLoad: number
  specificationTotalValidation: boolean
  OligoIndex: number
  isModificationPopup: boolean
  isConfirmOrder: boolean
  isDisplayError: boolean
  stepNo: number
  callSessionAPI: boolean
  countryCode: string
  isDeletePerform: boolean
  resetValidation: boolean
  totalValidationJSON: any
  aquaInternalMod?: string | null | undefined
  pageError: string
  errorIcon: boolean
  productInformation: ProductInformationResponse
  optionalBaseChanged: boolean
  confirmOrder: boolean
  bulkReview: boolean
  isTubePageLoad: boolean
  isAmountChanged: boolean
  isFormatChanged: boolean
  isConcentrationEnable: boolean
  isTubeItemDelete: boolean
  isViewAllClick: boolean
  isRequiredFieldError: boolean
  callOverrideValidation: boolean
  specificationWarningMsg?: string[] | null | undefined
  fiveModError?: string[] | null | undefined
  threeModError?: string[] | null | undefined
  onContinueButtonPriceCall: boolean
  isResetError: boolean
  isComingFromReviewPage: boolean
  fiveModThreeModErr?: string[] | null | undefined
  callRuleValidation: boolean
  isDeleteAll: boolean
  isLabelledAminoAcidError: boolean
  isComingFromConfirmPage: boolean
  isAddOligoFromConfirmPage: boolean
  isSideNavLinkDisabled: boolean
  focusOnSequenceBox: boolean
  applyToAllTotalValidation: boolean
  isSessionDataRetrieved: boolean
}

export const initialState: StandardState = {
  addOligo: false,
  applyToAllTotalValidation: false,
  aquaInternalMod: '',
  bulkReview: false,
  callOverrideValidation: false,
  callRuleValidation: false,
  callSessionAPI: false,
  callTotalValidation: false,
  confirmOrder: false,
  countryCode: '',
  currentOligoIndex: 0,
  errorData: {
    name: '',
    sequence: '',
    scale: '',
    purification: '',
    fiveMod: '',
    threeMod: '',
    researcher: '',
    format: 'DRY',
    concentration: '',
    tubes: '1',
    countryCode: '',
    fullSOligoBackbone: false,
    isOverridden: false,
    comments: '',
    cterminalMod: '',
    nterminalMod: '',
    otherValue: '',
    amount: '',
    isLabelledAminoAcid: true,
    quantitation: '',
    purityLevel: '',
    conjugation: 'None',
    conjugationAmount: '',
    conjugationChemistry: '',
    additionalCarrierProtein: 'None',
    additionalServices: [],
    flag: 0,
    internalMod: '',
    probeType: '',
  },
  errorIcon: false,
  errorResponseJson: {},
  fiveModError: [],
  fiveModThreeModErr: [],
  focusOnSequenceBox: false,
  isAddOligoFromConfirmPage: false,
  isAmountChanged: false,
  isComingFromConfirmPage: false,
  isComingFromReviewPage: false,
  isConcentrationEnable: false,
  isConfirmOrder: false,
  isDeleteAll: false,
  isDeletePerform: false,
  isDisplayError: false,
  isFormatChanged: false,
  isLabelledAminoAcidError: false,
  isModificationPopup: false,
  isPageLoad: 0,
  isRequiredFieldError: false,
  isResetError: true,
  isSequenceValid: false,
  isSessionDataRetrieved: false,
  isSideNavLinkDisabled: false,
  isTubeItemDelete: false,
  isTubePageLoad: false,
  isValidTotalValidation: false,
  isViewAllClick: false,
  oligoCount: 0,
  OligoIndex: 0,
  onContinueButtonPriceCall: false,
  optionalBaseChanged: false,
  optionalBases: '',
  pageError: '',
  productInformation: {
    productType: '',
    typeCode: '',
    packageType: '',
    instructions: '',
    brand: '',
    shippingOptions: [''],
    companionProducts: [''],
    currencyFormat: '',
    decimalSeparator: '',
    thousandSeparator: '',
    prefixCurrecny: true,
    thousandSpacing: '',
  },
  resetValidation: false,
  seqLength: 0,
  sessionData: [
    {
      additionalCarrierProtein: 'None',
      additionalComments: '',
      additionalServices: [],
      amount: '',
      applyToAll: false,
      autoValidation: 'false',
      baseCount: 0,
      carrierProtein: '',
      cartId: '',
      comments: '',
      concentration: '',
      conjugation: 'None',
      conjugationAmount: '',
      conjugationChemistry: '',
      countryCode: '',
      crossContamination: '',
      crRnaType: '',
      cterminalMod: '',
      currency: '',
      currencySymbol: '',
      customPeptideType: '',
      epsilon: 0,
      fiveMod: '',
      fiveModCategory: '',
      flag: 0,
      format: 'DRY',
      fullSOligoBackbone: false,
      gcContent: '',
      id: '1',
      internalMod: '',
      internalModCategory: '',
      isLabelledAminoAcid: true,
      isoCode: false,
      isOverridden: false,
      itemId: '',
      listError: [
        {
          key: '',
          value: '',
        },
      ],
      listWarning: [
        {
          key: '',
          value: '',
        },
      ],
      material: '',
      meltingTemparature: '',
      minimumYield: '',
      molecularWeight: '',
      name: '',
      nterminalMod: '',
      oligoId: 1,
      orderItemId: '',
      otherValue: '',
      packageType: '',
      plateType: '',
      price: '',
      primerDimer: '',
      probeType: '',
      productType: '',
      purification: '',
      purityLevel: '',
      quantitation: '',
      scale: '',
      secondaryStructure: '',
      sequence: '',
      sequenceLocation: '',
      shipping: '',
      threeMod: '',
      threeModCategory: '',
      tubes: '1',
    },
  ],
  setSequenceData: {
    sequenceData: '',
    selectionData: '',
    error: '',
    position: 0,
    baseCount: 0,
    seqLength: 0,
  },
  specificationTotalValidation: false,
  specificationWarningMsg: [],
  stepNo: 0,
  threeModError: [],
  totalValidation: {
    listErrors: [
      {
        key: '',
        value: '',
      },
    ],
  },
  totalValidationJSON: [],
}

type Action =
  | { type: 'INIT' }
  | { type: 'UPDATE_INPUT'; data: SessionData[] }
  | { type: 'UPDATE_ERROR_DATA'; data: RuleValidationData }
  | { type: 'UPDATE_ERROR_RESPONSE'; data: any }
  | { type: 'UPDATE_SEQUENCE_LENGTH'; data: number }
  | { type: 'UPDATE_VALID_SEQUENCE'; data: boolean }
  | { type: 'UPDATE_CURRENT_OLIGO_INDEX'; data: number }
  | { type: 'UPDATE_SET_SEQUENCE_DATA'; data: SetSequenceData }
  | { type: 'UPDATE_TOTALVALIDATION'; data: TubeTotalValidation }
  | { type: 'CALL_TOTAL_VALIDATION'; data: boolean }
  | { type: 'IS_VALID_TOTAL_VALIDATION'; data: boolean }
  | { type: 'SPECIFICATION_TOTAL_VALIDATION'; data: boolean }
  | { type: 'UPDATE_OPTIONAL_BASES'; data: string }
  | { type: 'UPDATE_PAGE_LOAD'; data: number }
  | { type: 'ADD_NEW_OLIGO'; data: number }
  | { type: 'IS_ADD_OLIGO'; data: boolean }
  | { type: 'UPDATE_OLIGO_INDEX'; data: number }
  | { type: 'IS_MODIFICATION_POPUP'; data: boolean }
  | { type: 'IS_CONFIRM_ORDER'; data: boolean }
  | { type: 'IS_DISPLAY_ERROR'; data: boolean }
  | { type: 'SET_STEP_NO'; data: number }
  | { type: 'CALL_SESSION_API'; data: boolean }
  | { type: 'COUNTRY_CODE'; data: string }
  | { type: 'IS_DELETE_PERFORM'; data: boolean }
  | { type: 'RESET_SPECIFICATION_ERROR_MSG'; data: boolean }
  | { type: 'TOTAL_VALIDATION_DATA'; data: any }
  | { type: 'UPDATE_AQUA_INTERNAL_MOD'; data: string }
  | { type: 'SET_PAGE_ERROR'; data: string }
  | { type: 'SET_ERROR_ICON'; data: boolean }
  | { type: 'SET_PRODUCT_INFORMATION'; data: ProductInformationResponse }
  | { type: 'OPTIONAL_BASES_CHANGED'; data: boolean }
  | { type: 'CONFIRM_ORDER'; data: boolean }
  | { type: 'IS_BULK_REVIEW'; data: boolean }
  | { type: 'IS_TUBE_PAGE_LOAD'; data: boolean }
  | { type: 'IS_AMOUNT_CHANGED'; data: boolean }
  | { type: 'IS_FORMAT_CHANGED'; data: boolean }
  | { type: 'IS_TUBE_ITEM_DELETE'; data: boolean }
  | { type: 'IS_VIEW_ALL_CLICK'; data: boolean }
  | { type: 'IS_REQUIRED_FIELD_ERROR'; data: boolean }
  | { type: 'CALL_OVERRIDE_VALIDATION'; data: boolean }
  | { type: 'SPECIFICATION_WARNING_MESSAGES'; data: string[] }
  | { type: 'FIVE_MOD_ERROR'; data: string[] }
  | { type: 'THREE_MOD_ERROR'; data: string[] }
  | { type: 'ON_CONTINUE_BUTTON_PRICECALL'; data: boolean }
  | { type: 'IS_RESET_ERROR'; data: boolean }
  | { type: 'FIVEMOD_THREEMOD_ERROR'; data: string[] }
  | { type: 'IS_COMING_FROM_REVIEW_PAGE'; data: boolean }
  | { type: 'CALL_RULE_VALIDATION'; data: boolean }
  | { type: 'IS_DELETE_ALL'; data: boolean }
  | { type: 'IS_LABEL_AMINO_ACID_ERROR'; data: boolean }
  | { type: 'IS_COMING_FROM_CONFIRM_PAGE'; data: boolean }
  | { type: 'IS_ADD_OLIGO_FROM_CONFIRM_PAGE'; data: boolean }
  | { type: 'IS_SIDE_NAV_DISABLE'; data: boolean }
  | { type: 'FOCUS_ON_SEQUENCEBOX'; data: boolean }
  | { type: 'IS_CONCENTRATION_ENABLE'; data: boolean }
  | { type: 'UPDATE_APPLY_TO_ALL_TOTAL_VALIDATION'; data: boolean }
  | { type: 'IS_SESSION_DATA_RETRIEVED'; data: boolean }

export interface ContextProps {
  state: StandardState
  dispatch: ({ type, data }) => void
}

export function reducer(state: StandardState, action: Action): StandardState {
  const keys = {
    ADD_NEW_OLIGO: 'oligoCount',
    CALL_OVERRIDE_VALIDATION: 'callOverrideValidation',
    CALL_RULE_VALIDATION: 'callRuleValidation',
    CALL_SESSION_API: 'callSessionAPI',
    CALL_TOTAL_VALIDATION: 'callTotalValidation',
    CONFIRM_ORDER: 'confirmOrder',
    COUNTRY_CODE: 'countryCode',
    FIVE_MOD_ERROR: 'fiveModError',
    FIVEMOD_THREEMOD_ERROR: 'fiveModThreeModErr',
    FOCUS_ON_SEQUENCEBOX: 'focusOnSequenceBox',
    IS_ADD_OLIGO: 'addOligo',
    IS_ADD_OLIGO_FROM_CONFIRM_PAGE: 'isAddOligoFromConfirmPage',
    IS_AMOUNT_CHANGED: 'isAmountChanged',
    IS_BULK_REVIEW: 'bulkReview',
    IS_COMING_FROM_CONFIRM_PAGE: 'isComingFromConfirmPage',
    IS_COMING_FROM_REVIEW_PAGE: 'isComingFromReviewPage',
    IS_CONCENTRATION_ENABLE: 'isConcentrationEnable',
    IS_CONFIRM_ORDER: 'isConfirmOrder',
    IS_DELETE_ALL: 'isDeleteAll',
    IS_DELETE_PERFORM: 'isDeletePerform',
    IS_DISPLAY_ERROR: 'isDisplayError',
    IS_FORMAT_CHANGED: 'isFormatChanged',
    IS_LABEL_AMINO_ACID_ERROR: 'isLabelledAminoAcidError',
    IS_MODIFICATION_POPUP: 'isModificationPopup',
    IS_REQUIRED_FIELD_ERROR: 'isRequiredFieldError',
    IS_RESET_ERROR: 'isResetError',
    IS_SESSION_DATA_RETRIEVED: 'isSessionDataRetrieved',
    IS_SIDE_NAV_DISABLE: 'isSideNavLinkDisabled',
    IS_TUBE_ITEM_DELETE: 'isTubeItemDelete',
    IS_TUBE_PAGE_LOAD: 'isTubePageLoad',
    IS_VALID_TOTAL_VALIDATION: 'isValidTotalValidation',
    IS_VIEW_ALL_CLICK: 'isViewAllClick',
    ON_CONTINUE_BUTTON_PRICECALL: 'onContinueButtonPriceCall',
    OPTIONAL_BASES_CHANGED: 'optionalBaseChanged',
    RESET_SPECIFICATION_ERROR_MSG: 'resetValidation',
    SET_ERROR_ICON: 'errorIcon',
    SET_PAGE_ERROR: 'pageError',
    SET_PRODUCT_INFORMATION: 'productInformation',
    SET_STEP_NO: 'stepNo',
    SPECIFICATION_TOTAL_VALIDATION: 'specificationTotalValidation',
    SPECIFICATION_WARNING_MESSAGES: 'specificationWarningMsg',
    THREE_MOD_ERROR: 'threeModError',
    TOTAL_VALIDATION_DATA: 'totalValidationJSON',
    UPDATE_APPLY_TO_ALL_TOTAL_VALIDATION: 'applyToAllTotalValidation',
    UPDATE_AQUA_INTERNAL_MOD: 'aquaInternalMod',
    UPDATE_CURRENT_OLIGO_INDEX: 'currentOligoIndex',
    UPDATE_ERROR_DATA: 'errorData',
    UPDATE_ERROR_RESPONSE: 'errorResponseJson',
    UPDATE_INPUT: 'sessionData',
    UPDATE_OLIGO_INDEX: 'OligoIndex',
    UPDATE_OPTIONAL_BASES: 'optionalBases',
    UPDATE_PAGE_LOAD: 'isPageLoad',
    UPDATE_SEQUENCE_LENGTH: 'seqLength',
    UPDATE_SET_SEQUENCE_DATA: 'setSequenceData',
    UPDATE_TOTALVALIDATION: 'totalValidation',
    UPDATE_VALID_SEQUENCE: 'isSequenceValid',
  }

  if (keys[action.type] && action.type !== 'INIT') {
    const newState = { ...state }
    newState[keys[action.type]] = action.data
    return newState
  } else {
    return initialState
  }
}

export const configContext = React.createContext({} as ContextProps)
